import { SecureScoreProfileConstants } from "./SecureScoreProfile";

export const COMPLIANCE_TYPES = {
  CIS_31: "CIS M365 3.1",
  CIS_20: "CIS M365 2.0",
  CISA_SCUBA: "CISA SCuBA",
  ESSENTIAL_8_L1: "Essential 8 L1",
  ESSENTIAL_8_L2: "Essential 8 L2",
  ESSENTIAL_8_L3: "Essential 8 L3",
  "NIST_CSF_2.0": "NIST CSF 2.0",
  CIS_M365_V5: "CIS M365 V5",
  CIS_V8: "CIS V8",
  CIS_V7: "CIS V7",
  CISA_M365_V5: "CISA M365 V5",
};

const secureScoreProfileConstants = new SecureScoreProfileConstants({
  COMPLIANCE_TYPES,
});

const { SECURE_SCORE_PROFILE_TYPES } = secureScoreProfileConstants;

// Maester postures - values should be equal the maester test ids
export const MAESTER_CHECK_TYPES = {
  MT_1031: "MT.1031",
  MT_1030: "MT.1030",
  MT_1026: "MT.1026",
  MT_1023: "MT.1023",
  MT_1022: "MT.1022",
  MT_1020: "MT.1020",
  MT_1019: "MT.1019",
  MT_1018: "MT.1018",
  MT_1017: "MT.1017",
  MT_1015: "MT.1015",
  MT_1014: "MT.1014",
  MT_1013: "MT.1013",
  MT_1011: "MT.1011",
  MT_1005: "MT.1005",
  MT_1004: "MT.1004",
  MT_1003: "MT.1003",
  MT_1002: "MT.1002",
  MT_1001: "MT.1001",
  MS_EXO_7_1: "CISA.MS.EXO.7.1",
  MS_EXO_6_2: "CISA.MS.EXO.6.2",
  MS_EXO_6_1: "CISA.MS.EXO.6.1",
  MS_EXO_5_1: "CISA.MS.EXO.5.1",
  MS_EXO_4_3: "CISA.MS.EXO.4.3",
  MS_EXO_4_2: "CISA.MS.EXO.4.2",
  MS_EXO_4_1: "CISA.MS.EXO.4.1",
  MS_EXO_2_2: "CISA.MS.EXO.2.2",
  MS_EXO_2_1: "CISA.MS.EXO.2.1",
  MS_AAD_8_2: "CISA.MS.AAD.8.2",
  MS_AAD_8_1: "CISA.MS.AAD.8.1",
  MS_AAD_7_1: "CISA.MS.AAD.7.1",
  MS_AAD_6_1: "CISA.MS.AAD.6.1",
  MS_AAD_5_3: "CISA.MS.AAD.5.3",
  MS_AAD_5_1: "CISA.MS.AAD.5.1",
  MS_AAD_3_8: "CISA.MS.AAD.3.8",
  MS_AAD_3_7: "CISA.MS.AAD.3.7",
  MS_AAD_3_6: "CISA.MS.AAD.3.6",
  MS_AAD_3_5: "CISA.MS.AAD.3.5",
  MS_AAD_3_3: "CISA.MS.AAD.3.3",
  MS_AAD_3_1: "CISA.MS.AAD.3.1",
  MS_AAD_2_3: "CISA.MS.AAD.2.3",
  MS_AAD_2_1: "CISA.MS.AAD.2.1",
  EIDSCA_PR06: "EIDSCA.PR06",
  EIDSCA_PR05: "EIDSCA.PR05",
  EIDSCA_PR03: "EIDSCA.PR03",
  EIDSCA_PR02: "EIDSCA.PR02",
  EIDSCA_PR01: "EIDSCA.PR01",
  EIDSCA_CP03: "EIDSCA.CP03",
  EIDSCA_AV01: "EIDSCA.AV01",
  EIDSCA_AT02: "EIDSCA.AT02",
  EIDSCA_AP14: "EIDSCA.AP14",
  EIDSCA_AP10: "EIDSCA.AP10",
  EIDSCA_AP09: "EIDSCA.AP09",
  EIDSCA_AP08: "EIDSCA.AP08",
  EIDSCA_AP07: "EIDSCA.AP07",
  MS_EXO_12_2: "CISA.MS.EXO.12.2",
  MS_EXO_12_1: "CISA.MS.EXO.12.1",
  MS_AAD_7_6: "CISA.MS.AAD.7.6",
  MS_AAD_7_5: "CISA.MS.AAD.7.5",
  MS_AAD_7_4: "CISA.MS.AAD.7.4",
  MS_AAD_7_3: "CISA.MS.AAD.7.3",
  EIDSCA_CR04: "EIDSCA.CR04",
  EIDSCA_CR03: "EIDSCA.CR03",
  EIDSCA_CR02: "EIDSCA.CR02",
  MS_AAD_7_2: "CISA.MS.AAD.7.2",
  EIDSCA_AM09: "EIDSCA.AM09",
  EIDSCA_AM06: "EIDSCA.AM06",
  EIDSCA_AG02: "EIDSCA.AG02",
  EIDSCA_AF02: "EIDSCA.AF02",
  EIDSCA_AF01: "EIDSCA.AF01",
};

export const SECURE_CHECK_TYPES = {
  ADMIN_MFA: "adminmfa",
  USER_MFA: "usermfa",
  LOGIN_PORTAL_BRANDING: "loginportalbranding",
  SELF_SERVE_PASSWORD_RESET: "selfservepasswordreset",
  BLOCK_LEGACY_AUTHENTICATION: "blocklegacyauthentication",
  INACTIVE_ACCOUNTS: "inactiveaccounts",
  TEAMS_DEFAULT_EXTERNAL_OPTIONS: "teamsdefaultexternaloptions",
  SHAREPOINT_EXTERNAL_GUEST_SHARING: "sharepointexternalguestsharing",
  RISKY_IPS: "riskyips",
  RISKY_COUNTRIES: "riskycountries",
  UNIFIED_AUDIT_LOG: "unifiedauditlog",
  SAFE_ATTACHMENT: "safeattachment",
  EXTERNAL_MAIL_FORWARDING: "externalmailforwarding",
  CONNECTED_APPS_ADMIN_CONSENT: "connectedappsadminconsent",
  BLOCK_SIGN_IN_SHARED_MAILBOXES: "blocksigninsharedmailboxes",
  MAILBOX_AUDIT: "mailboxaudit",
  EXTERNAL_MAIL_TAG: "externalMailTag",
  POWERSHELL_ACCESS_FOR_NON_ADMINS: "powershellaccessfornonadmins",
  DKIM: "dkim",
  RESHARING_BY_EXTERNAL_USERS: "resharingbyexternalusers",
  CONTACT_SETTINGS: "contactsettings",
  SITE_CREATION_FOR_STANDARD_USERS: "sitecreationforstandardusers",
  DELETED_USER_ONE_DRIVE_RETENTION: "deleteduseronedriveretention",
  MFA_NUMBER_MATCHING: "mfanumbermatching",
  ENABLE_EXCHANGE_MODERN_AUTH: "enableexchangemodernauth",
  ENTRA_ID_GUEST_USER_ACCESS_PERMISSIONS: "entraIdGuestUserAccessPermissions",
  TEMPORARY_ACCESS_PASS: "temporaryaccesspass",
  ACTIVITY_BASED_TIMEOUT_POLICY: "activitybasedtimeoutpolicy",
  MFA_CAMPAIGN: "mfacampaign",
  REJECT_DIRECT_SEND: "rejectDirectSend",
  // maester postures
  ...MAESTER_CHECK_TYPES,

  // additional secure score profile types
  ...SECURE_SCORE_PROFILE_TYPES,
};

export const SECURE_CHECK_MESSAGES = {
  [SECURE_CHECK_TYPES.ADMIN_MFA]: "SECURE_CHECK.ADMIN_MFA",
  [SECURE_CHECK_TYPES.USER_MFA]: "SECURE_CHECK.USER_MFA",
  [SECURE_CHECK_TYPES.LOGIN_PORTAL_BRANDING]:
    "SECURE_CHECK.LOGIN_PORTAL_BRANDING",
  [SECURE_CHECK_TYPES.SELF_SERVE_PASSWORD_RESET]:
    "SECURE_CHECK.SELF_SERVE_PASSWORD_RESET",
  [SECURE_CHECK_TYPES.BLOCK_LEGACY_AUTHENTICATION]:
    "SECURE_CHECK.BLOCK_LEGACY_AUTHENTICATION",
  [SECURE_CHECK_TYPES.INACTIVE_ACCOUNTS]: "SECURE_CHECK.INACTIVE_ACCOUNTS",
  [SECURE_CHECK_TYPES.TEAMS_DEFAULT_EXTERNAL_OPTIONS]:
    "SECURE_CHECK.TEAMS_DEFAULT_EXTERNAL_OPTIONS",
  [SECURE_CHECK_TYPES.SHAREPOINT_EXTERNAL_GUEST_SHARING]:
    "SECURE_CHECK.SHAREPOINT_EXTERNAL_GUEST_SHARING",
  [SECURE_CHECK_TYPES.RISKY_IPS]: "SECURE_CHECK.RISKY_IPS",
  [SECURE_CHECK_TYPES.RISKY_COUNTRIES]: "SECURE_CHECK.RISKY_COUNTRIES",
  [SECURE_CHECK_TYPES.UNIFIED_AUDIT_LOG]: "SECURE_CHECK.UNIFIED_AUDIT_LOG",
  [SECURE_CHECK_TYPES.SAFE_ATTACHMENT]: "SECURE_CHECK.SAFE_ATTACHMENT",
  [SECURE_CHECK_TYPES.EXTERNAL_MAIL_FORWARDING]:
    "SECURE_CHECK.EXTERNAL_MAIL_FORWARDING",
  [SECURE_CHECK_TYPES.CONNECTED_APPS_ADMIN_CONSENT]:
    "SECURE_CHECK.CONNECTED_APPS_ADMIN_CONSENT",
  [SECURE_CHECK_TYPES.BLOCK_SIGN_IN_SHARED_MAILBOXES]:
    "SECURE_CHECK.BLOCK_SIGN_IN_SHARED_MAILBOXES",
  [SECURE_CHECK_TYPES.MAILBOX_AUDIT]: "SECURE_CHECK.MAILBOX_AUDIT",
  [SECURE_CHECK_TYPES.EXTERNAL_MAIL_TAG]: "SECURE_CHECK.EXTERNAL_MAIL_TAG",
  [SECURE_CHECK_TYPES.POWERSHELL_ACCESS_FOR_NON_ADMINS]:
    "SECURE_CHECK.POWERSHELL_ACCESS_FOR_NON_ADMINS",
  [SECURE_CHECK_TYPES.DKIM]: "SECURE_CHECK.DKIM",
  [SECURE_CHECK_TYPES.RESHARING_BY_EXTERNAL_USERS]:
    "SECURE_CHECK.RESHARING_BY_EXTERNAL_USERS",
  [SECURE_CHECK_TYPES.CONTACT_SETTINGS]: "SECURE_CHECK.CONTACT_SETTINGS",
  [SECURE_CHECK_TYPES.SITE_CREATION_FOR_STANDARD_USERS]:
    "SECURE_CHECK.SITE_CREATION_FOR_STANDARD_USERS",
  [SECURE_CHECK_TYPES.DELETED_USER_ONE_DRIVE_RETENTION]:
    "SECURE_CHECK.DELETED_USER_ONE_DRIVE_RETENTION",
  [SECURE_CHECK_TYPES.MFA_NUMBER_MATCHING]: "SECURE_CHECK.MFA_NUMBER_MATCHING",
  [SECURE_CHECK_TYPES.ENABLE_EXCHANGE_MODERN_AUTH]:
    "SECURE_CHECK.ENABLE_EXCHANGE_MODERN_AUTH",
  [SECURE_CHECK_TYPES.ENTRA_ID_GUEST_USER_ACCESS_PERMISSIONS]:
    "SECURE_CHECK.ENTRA_ID_GUEST_USER_ACCESS_PERMISSIONS",
  [SECURE_CHECK_TYPES.TEMPORARY_ACCESS_PASS]:
    "SECURE_CHECK.TEMPORARY_ACCESS_PASS",
  [SECURE_CHECK_TYPES.ACTIVITY_BASED_TIMEOUT_POLICY]:
    "SECURE_CHECK.ACTIVITY_BASED_TIMEOUT_POLICY",
  [SECURE_CHECK_TYPES.MFA_CAMPAIGN]: "SECURE_CHECK.MFA_CAMPAIGN",
  [SECURE_CHECK_TYPES.REJECT_DIRECT_SEND]:
    "SECURE_CHECK.REJECT_DIRECT_SEND",

  // maester
  [SECURE_CHECK_TYPES.MT_1031]: "SECURE_CHECK.MT_1031",
  [SECURE_CHECK_TYPES.MT_1030]: "SECURE_CHECK.MT_1030",
  [SECURE_CHECK_TYPES.MT_1026]: "SECURE_CHECK.MT_1026",
  [SECURE_CHECK_TYPES.MT_1023]: "SECURE_CHECK.MT_1023",
  [SECURE_CHECK_TYPES.MT_1022]: "SECURE_CHECK.MT_1022",
  [SECURE_CHECK_TYPES.MT_1020]: "SECURE_CHECK.MT_1020",
  [SECURE_CHECK_TYPES.MT_1019]: "SECURE_CHECK.MT_1019",
  [SECURE_CHECK_TYPES.MT_1018]: "SECURE_CHECK.MT_1018",
  [SECURE_CHECK_TYPES.MT_1017]: "SECURE_CHECK.MT_1017",
  [SECURE_CHECK_TYPES.MT_1015]: "SECURE_CHECK.MT_1015",
  [SECURE_CHECK_TYPES.MT_1014]: "SECURE_CHECK.MT_1014",
  [SECURE_CHECK_TYPES.MT_1013]: "SECURE_CHECK.MT_1013",
  [SECURE_CHECK_TYPES.MT_1011]: "SECURE_CHECK.MT_1011",
  [SECURE_CHECK_TYPES.MT_1005]: "SECURE_CHECK.MT_1005",
  [SECURE_CHECK_TYPES.MT_1004]: "SECURE_CHECK.MT_1004",
  [SECURE_CHECK_TYPES.MT_1003]: "SECURE_CHECK.MT_1003",
  [SECURE_CHECK_TYPES.MT_1002]: "SECURE_CHECK.MT_1002",
  [SECURE_CHECK_TYPES.MT_1001]: "SECURE_CHECK.MT_1001",
  [SECURE_CHECK_TYPES.MS_EXO_7_1]: "SECURE_CHECK.MS_EXO_7_1",
  [SECURE_CHECK_TYPES.MS_EXO_6_2]: "SECURE_CHECK.MS_EXO_6_2",
  [SECURE_CHECK_TYPES.MS_EXO_6_1]: "SECURE_CHECK.MS_EXO_6_1",
  [SECURE_CHECK_TYPES.MS_EXO_5_1]: "SECURE_CHECK.MS_EXO_5_1",
  [SECURE_CHECK_TYPES.MS_EXO_4_3]: "SECURE_CHECK.MS_EXO_4_3",
  [SECURE_CHECK_TYPES.MS_EXO_4_2]: "SECURE_CHECK.MS_EXO_4_2",
  [SECURE_CHECK_TYPES.MS_EXO_4_1]: "SECURE_CHECK.MS_EXO_4_1",
  [SECURE_CHECK_TYPES.MS_EXO_2_2]: "SECURE_CHECK.MS_EXO_2_2",
  [SECURE_CHECK_TYPES.MS_EXO_2_1]: "SECURE_CHECK.MS_EXO_2_1",
  [SECURE_CHECK_TYPES.MS_AAD_8_2]: "SECURE_CHECK.MS_AAD_8_2",
  [SECURE_CHECK_TYPES.MS_AAD_8_1]: "SECURE_CHECK.MS_AAD_8_1",
  [SECURE_CHECK_TYPES.MS_AAD_7_1]: "SECURE_CHECK.MS_AAD_7_1",
  [SECURE_CHECK_TYPES.MS_AAD_6_1]: "SECURE_CHECK.MS_AAD_6_1",
  [SECURE_CHECK_TYPES.MS_AAD_5_3]: "SECURE_CHECK.MS_AAD_5_3",
  [SECURE_CHECK_TYPES.MS_AAD_5_1]: "SECURE_CHECK.MS_AAD_5_1",
  [SECURE_CHECK_TYPES.MS_AAD_3_8]: "SECURE_CHECK.MS_AAD_3_8",
  [SECURE_CHECK_TYPES.MS_AAD_3_7]: "SECURE_CHECK.MS_AAD_3_7",
  [SECURE_CHECK_TYPES.MS_AAD_3_6]: "SECURE_CHECK.MS_AAD_3_6",
  [SECURE_CHECK_TYPES.MS_AAD_3_5]: "SECURE_CHECK.MS_AAD_3_5",
  [SECURE_CHECK_TYPES.MS_AAD_3_3]: "SECURE_CHECK.MS_AAD_3_3",
  [SECURE_CHECK_TYPES.MS_AAD_3_1]: "SECURE_CHECK.MS_AAD_3_1",
  [SECURE_CHECK_TYPES.MS_AAD_2_3]: "SECURE_CHECK.MS_AAD_2_3",
  [SECURE_CHECK_TYPES.MS_AAD_2_1]: "SECURE_CHECK.MS_AAD_2_1",
  [SECURE_CHECK_TYPES.EIDSCA_PR06]: "SECURE_CHECK.EIDSCA_PR06",
  [SECURE_CHECK_TYPES.EIDSCA_PR05]: "SECURE_CHECK.EIDSCA_PR05",
  [SECURE_CHECK_TYPES.EIDSCA_PR03]: "SECURE_CHECK.EIDSCA_PR03",
  [SECURE_CHECK_TYPES.EIDSCA_PR02]: "SECURE_CHECK.EIDSCA_PR02",
  [SECURE_CHECK_TYPES.EIDSCA_PR01]: "SECURE_CHECK.EIDSCA_PR01",
  [SECURE_CHECK_TYPES.EIDSCA_CP03]: "SECURE_CHECK.EIDSCA_CP03",
  [SECURE_CHECK_TYPES.EIDSCA_AV01]: "SECURE_CHECK.EIDSCA_AV01",
  [SECURE_CHECK_TYPES.EIDSCA_AT02]: "SECURE_CHECK.EIDSCA_AT02",
  [SECURE_CHECK_TYPES.EIDSCA_AP14]: "SECURE_CHECK.EIDSCA_AP14",
  [SECURE_CHECK_TYPES.EIDSCA_AP10]: "SECURE_CHECK.EIDSCA_AP10",
  [SECURE_CHECK_TYPES.EIDSCA_AP09]: "SECURE_CHECK.EIDSCA_AP09",
  [SECURE_CHECK_TYPES.EIDSCA_AP08]: "SECURE_CHECK.EIDSCA_AP08",
  [SECURE_CHECK_TYPES.EIDSCA_AP07]: "SECURE_CHECK.EIDSCA_AP07",
  [SECURE_CHECK_TYPES.MS_EXO_12_2]: "SECURE_CHECK.MS_EXO_12_2",
  [SECURE_CHECK_TYPES.MS_EXO_12_1]: "SECURE_CHECK.MS_EXO_12_1",
  [SECURE_CHECK_TYPES.MS_AAD_7_6]: "SECURE_CHECK.MS_AAD_7_6",
  [SECURE_CHECK_TYPES.MS_AAD_7_5]: "SECURE_CHECK.MS_AAD_7_5",
  [SECURE_CHECK_TYPES.MS_AAD_7_4]: "SECURE_CHECK.MS_AAD_7_4",
  [SECURE_CHECK_TYPES.MS_AAD_7_3]: "SECURE_CHECK.MS_AAD_7_3",
  [SECURE_CHECK_TYPES.EIDSCA_CR04]: "SECURE_CHECK.EIDSCA_CR04",
  [SECURE_CHECK_TYPES.EIDSCA_CR03]: "SECURE_CHECK.EIDSCA_CR03",
  [SECURE_CHECK_TYPES.EIDSCA_CR02]: "SECURE_CHECK.EIDSCA_CR02",
  [SECURE_CHECK_TYPES.MS_AAD_7_2]: "SECURE_CHECK.MS_AAD_7_2",
  [SECURE_CHECK_TYPES.EIDSCA_AM09]: "SECURE_CHECK.EIDSCA_AM09",
  [SECURE_CHECK_TYPES.EIDSCA_AM06]: "SECURE_CHECK.EIDSCA_AM06",
  [SECURE_CHECK_TYPES.EIDSCA_AG02]: "SECURE_CHECK.EIDSCA_AG02",
  [SECURE_CHECK_TYPES.EIDSCA_AF02]: "SECURE_CHECK.EIDSCA_AF02",
  [SECURE_CHECK_TYPES.EIDSCA_AF01]: "SECURE_CHECK.EIDSCA_AF01",
};

export const SHORTCUTS = {
  CONFIGURE: "configure",
  INSTRUCTIONS: "instructions",
  CAP: "cap",
  DEFENDER: "defender",
};

export const AUGMENTT_POSTURE_STATES = {
  COMPLIANT: "Configured",
  PARTIALLY_COMPLIANT: "Partially Configured",
  NOT_COMPLIANT: "Not Configured",
  NOT_MEASURED: "Not Measured",
  RESOLVED: "Resolved",
};

export const MICROSOFT_POSTURE_STATES = {
  DEFAULT: "Default",
  RISK_ACCEPTED: "Ignored",
  THIRD_PARTY: "ThirdParty",
  ALTERNATE_MITIGATION: "AlternateMitigation",
};

export const POSTURE_STATE_COLOR_CODES = {
  [AUGMENTT_POSTURE_STATES.COMPLIANT]: "success",
  [AUGMENTT_POSTURE_STATES.PARTIALLY_COMPLIANT]: "warning",
  [AUGMENTT_POSTURE_STATES.NOT_COMPLIANT]: "danger",
  [AUGMENTT_POSTURE_STATES.NOT_MEASURED]: "secondary",
  [AUGMENTT_POSTURE_STATES.RESOLVED]: "primary",
};

export const POSTURE_STATE_TO_MSG = {
  [AUGMENTT_POSTURE_STATES.COMPLIANT]: "SECURE.POSTURE.CONFIGURED",
  [AUGMENTT_POSTURE_STATES.PARTIALLY_COMPLIANT]:
    "SECURE.POSTURE.PARTIALLY_CONFIGURED",
  [AUGMENTT_POSTURE_STATES.NOT_COMPLIANT]: "SECURE.POSTURE.NOT_CONFIGURED",
  [AUGMENTT_POSTURE_STATES.NOT_MEASURED]: "SECURE.POSTURE.NOT_MEASURED",
  [AUGMENTT_POSTURE_STATES.RESOLVED]: "SECURE.POSTURE.RESOLVED",
  [MICROSOFT_POSTURE_STATES.DEFAULT]:
    "SECURITY_CHECK.STATE.AUGMENTT_COMPLIANCE",
  [MICROSOFT_POSTURE_STATES.RISK_ACCEPTED]:
    "SECURITY_CHECK.STATE.RISK_ACCEPTED",
  [MICROSOFT_POSTURE_STATES.THIRD_PARTY]: "SECURITY_CHECK.STATE.THIRD_PARTY",
  [MICROSOFT_POSTURE_STATES.ALTERNATE_MITIGATION]:
    "SECURITY_CHECK.STATE.ALTERNATE_MITIGATION",
};

export const EXTERNAL_MAIL_FORWARDING_OPTIONS = [
  { label: "On: Forwarding is enabled", value: "On" },
  { label: "Automatic - System controlled", value: "Automatic" },
  { label: "Off: Forwarding is disabled", value: "Off" },
];
